import { Banner, BannerContent, BannerIcon, BannerTitle, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { ErrorBoundary } from 'react-error-boundary';
import { useThreadFiles } from '../../hooks/useThreadFiles';
import { useAIAssistant } from '../../store';
import File, { FileSkeleton } from '../elements/File';

interface FileToolProps {
  part: any;
}

const FileToolError = () => {
  return (
    <div className='my-4'>
      <Banner color='danger'>
        <BannerIcon icon={<Icon color='danger' name='x' />} />
        <BannerContent>
          <BannerTitle>Ocorreu um erro ao carregar os arquivos</BannerTitle>
          <Typography>Ocorreu um erro ao carregar os arquivos. Por favor, tente novamente mais tarde.</Typography>
        </BannerContent>
      </Banner>
    </div>
  );
};

const FileTool = ({ part }: FileToolProps) => {
  const { threadId } = useAIAssistant();

  const existOutput = part?.output && typeof part?.output === 'object' && part?.output?.type === 'bash_code_execution_result';

  const existContentToDownload =
    existOutput && Array.isArray(part?.output?.content) && part?.output?.content?.some((content: any) => content && typeof content === 'object' && content.file_id);

  const { data: files, isLoading } = useThreadFiles(threadId || '', { enabled: !!threadId });
  const filesFiltered = files?.data?.filter((file) => file.toolCallId === (part as any).toolCallId);

  if (!threadId) return null;
  if (isLoading && existContentToDownload) return <FileSkeleton />;
  return <File files={filesFiltered || []} />;
};

const FileToolWithErrorBoundary = ({ part }: FileToolProps) => {
  return (
    <ErrorBoundary
      fallback={<FileToolError />}
      onError={(error, errorInfo) => {
        console.error(error, errorInfo);
      }}
    >
      <FileTool part={part} />
    </ErrorBoundary>
  );
};

export default FileToolWithErrorBoundary;
